import accountApi from '@/apis/accounts/accountAPI';
import commonFn from '@/commons/commonFunction';
import { loadLanguageAsync } from '@/i18ns/i18n';
import webSocket from '@/sockets/socket';
import store from '../store';

/**
 * Dang ky socket
 * @param {*} token
 */
async function initSocket(context, data) {
  if (data) {
    if (webSocket._connection?.state != 'Connected') {
      await webSocket.init(data.Token);
      startConnect(data);
    }
  }
}

async function startConnect(data) {
  await webSocket.startConnect();
}

async function resetGlobalContext(context) {
  await context.dispatch('globalcontext/resetGlobalContext', null, { root: true });
}

async function addGroupConnect(data) {
  if (webSocket._connection?.state == 'Connected') {
    //lắng nghe sự kiện hiện tại
    if (data.User) {
      webSocket.listenEvent('SendMessageToMultipleGroups');
      let res = await accountApi.getAllPartner();
      if (res && res.Data) {
        if (res.Data) {
          try {
            let partners = res?.Data?.map((item) => item.partner_id);
            if (partners && partners.length > 0) {
              if (webSocket._connection?.state == 'Connected') {
                await webSocket.joinGroups(partners);
              }
            }
          } catch (ex) {
            console.log(ex);
          }
        }
      }
    }
  }
}

export default {
  async getConfigInfo(context, payload) {
    try {
      context.commit('updateConfig', { CurrentDate: new Date() });
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin config:: ', ex);
    }
  },
  async setOrganizationUnit(context, payload) {
    context.commit('updateOrganizationUnit', payload);
  },

  /**
   * Đăng nhập
   */
  async loginCode(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.login(payload);
    context.commit('updateLoading', false);
    if (res && res.Data) {
      if (res.Data.token) {
        context.commit('updateToken', res.Data);
        await resetGlobalContext(context);
        context.dispatch('resolveDateFormat');
      }
    }
    return res;
  },

  async initConnectSocket(context, payload) {
    try {
      await initSocket(context, payload);
    } catch (ex) {
      console.log(ex);
    }
  },
  /**
   * Đăng nhập
   */
  async sendVerifyTwoFactor(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.sendVerifyTwoFactorFunc(payload);
    context.commit('updateLoading', false);
    if (res && res.Data) {
      if (res.Data.token) {
        context.commit('updateToken', res.Data);
        await resetGlobalContext(context);
        context.dispatch('resolveDateFormat');
      }
    }
    return res;
  },

  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   */
  async loginCallback(context, payload) {
    context.commit('updateLoading', true);
    var res = await accountApi.loginCallback(payload);

    context.commit('updateLoading', false);

    if (res) {
      if (res.Token) {
        context.commit('updateToken', res);
        await resetGlobalContext(context);
        context.dispatch('resolveDateFormat');
      }

      return res;
    }
  },

  /**
   * Đăng xuất
   */
  async logout(context, payload) {
    // try {
    //   if (webSocket._connection?.state == 'Connected') {
    //     let partners = store?.state?.globalcontext?.Partners?.map(
    //       (item) => item.partner_id
    //     );
    //     if (partners && partners.length > 0) {
    //     await  webSocket.leaveGroups(partners);
    //     }
    //   }
    //   await webSocket.stop();
    // } catch {}
    await webSocket.stop();
    context.commit('removeToken');
  },

  /**
   * Lấy token
   */
  async getToken(context, payload) {
    context.commit('updateLoading', true);

    // //request
    // let url = [window._apis.Auth, "/accounts/token"].join('');
    // // console.log('url ' + url);
    // let res = await axios.get(url, {
    //   params: payload,
    //   withCredentials: true
    // });
    var res = await accountApi.getToken(payload);

    context.commit('updateLoading', false);

    if (res) {
      context.commit('updateToken', res);
      await resetGlobalContext(context);
      return res;
    }
  },
  /**
   * Lấy thông tin phân quyền
   */
  async getPermission(context, payload) {
    context.commit('updateLoading', true);
    //request
    var res = await accountApi.getPermission(payload);

    context.commit('updateLoading', false);

    if (res) {
      context.commit('updatePermission', res);
    }

    return res;
  },

  /**
   * Đăng xuất
   */
  async logoff(context) {
    await accountApi.logoff();

    //remove token
    context.commit('removeToken');
  },
  /**
   * remove token
   */
  async removeToken(context) {
    //remove token
    try {
      if (webSocket._connection?.state == 'Connected') {
        let partners = store?.state?.globalcontext?.Partners?.map((item) => item.partner_id);
        if (partners && partners.length > 0) {
          await webSocket.leaveGroups(partners);
        }
      }
      await webSocket.stop();
    } catch {}
    context.commit('removeToken');
  },
  /*
   * Lấy trạng thái collapse của left menu
   */
  getLeftMenuCollapse(context, payload) {
    context.commit('updateLeftMenuCollapse', payload);
  },
  /**
   * Cập nhật posted date
   * @param {*} context
   * @param {*} payload
   * tbngoc 28/07/2022
   */
  updatePostedDateContext(context, payload) {
    context.commit('updatePostedDate', payload);
  },

  updateCulture(context, payload) {
    loadLanguageAsync(payload).then(() => {
      commonFn.setLocalStorage('culture', payload);
      context.commit('updateCulture', payload);
    });
  },

  /**
   * kiểm tra xem có load form không
   * @param {*} state
   * @param {*} data
   */
  updateLoadFormMaster(context, data) {
    context.commit('updateLoadFormMaster', data);
  },

  /**
   * @created by lvduy
   * @createdDate 2026-06-18
   * @description Giải quyết định dạng ngày cho người dùng đang đăng nhập.
   * date_format lưu DB theo C# convention (dd/MM/yyyy / MM/dd/yyyy).
   * Uppercase trước khi lưu store để moment.js đọc được (DD/MM/YYYY / MM/DD/YYYY).
   */
  resolveDateFormat(context) {
    const user = context.state.User;
    const raw = user?.DateFormat || user?.date_format;
    const dateFormat = raw ? raw.toUpperCase() : 'DD/MM/YYYY';
    context.commit('updateDateFormat', dateFormat);
  },
};
